import React, { Component } from 'react';
import './draggablePanel.styles.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonActions from '../../app/common/common.action';

class DraggablePanel extends Component {
    constructor(props) {
        super(props);

        this.dragMouseDown = this.dragMouseDown.bind(this);
        this.fecharDraggablePanel = this.fecharDraggablePanel.bind(this);

        this.state = {
            visible: false,
            children: null,
            title: null
        }
    }

    componentDidUpdate(_prevProps, prevState) {
        if (this.props.children && prevState.children === null) {
            this.setState({
                visible: true,
                children: this.props.children,
                title: this.props.title
            })
        }
    }

    fecharDraggablePanel() {
        this.setState({ visible: false, children: null, title: null });
        this.props.commonActions.preencherDraggablePanelContent(undefined, undefined);
    }

    render() {
        return this.state.visible
            ?
            (
                <div className="mv-draggablePanel" ref={el => (this.draggablePanel = el)}>
                    <div className="header" onMouseDown={this.dragMouseDown}>
                        {this.state.title}
                        <button onClick={this.fecharDraggablePanel}>
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                    {
                        this.state.children
                    }
                </div>
            )
            : null;
    }

    dragMouseDown(ev) {
        var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

        ev = ev || window.event;
        ev.preventDefault();

        pos3 = ev.clientX;
        pos4 = ev.clientY;

        document.onmousemove = (e) => {
            e = e || window.event;
            e.preventDefault();

            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;

            let top = this.draggablePanel.offsetTop - pos2 < 0 ? 0 : this.draggablePanel.offsetTop - pos2;
            let left = this.draggablePanel.offsetLeft - pos1 < 0 ? 0 : this.draggablePanel.offsetLeft - pos1;

            this.draggablePanel.style.top = top + "px";
            this.draggablePanel.style.left = left + "px";
        };

        document.onmouseup = () => {
            document.onmouseup = null;
            document.onmousemove = null;
        };
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(null, mapDispatchToProps)(DraggablePanel)


// WEBPACK FOOTER //
// ./src/componentes/floatingPanel/DraggablePanel.component.js